export default "//yastatic.net/s3/distribution/pythia/frontend/_/7d77c66f89167ffd27832efe852b043c.jpeg";